import { useTranslation } from "react-i18next";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  
  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "ar" : "en";
    i18n.changeLanguage(newLang);
    document.documentElement.dir = newLang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = newLang;
  };
  
  return (
    <button 
      onClick={toggleLanguage}
      className="px-5 py-2.5 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5"
      style={{ 
        background: '#ffde21',
        color: '#2d2d2b'
      }}
    >
      {i18n.language === "en" ? "العربية" : "English"}
    </button>
  );
}